<template>
  <UniversalDialog
    persistent
    overlay-opacity="0.6"
    max-width="640"
    :value="openDialog"
  >
    <template v-slot:footer="footerProps">
      <UniversalButton
        :disabled="(required && !value && !select_value) || footerProps.invalid"
        width="120"
        @click="confirm()"
        :color="okvariant"
      >
        {{ $t("gbl-ok") }}
      </UniversalButton>

      <UniversalButton
        width="120"
        @click="dismiss()"
        :color="cancelvariant"
        secondary
      >
        {{ $t("msgbox-cancel") }}
      </UniversalButton>
    </template>

    <template v-slot:title>
      <v-row
        ><v-col cols="11">{{ title }}</v-col
        ><v-col cols="1" class="text-right"
          ><v-btn
            style="margin-right: 0"
            v-if="showClose"
            icon
            @click="dismiss()"
            ><v-icon>mdi-close</v-icon></v-btn
          ></v-col
        ></v-row
      >
    </template>

    <template v-slot:default>
      <span v-if="text">{{ text }}</span>
      <ValidationObserver v-if="required" ref="obs" v-slot="{}">
        <ValidationProvider
          v-if="label"
          rules="required"
          v-slot="{ errors, valid }"
        >
          <FormTextInput
            v-model="value"
            :label="label"
            :error-messages="errors"
            :success="valid"
            required
          ></FormTextInput>
        </ValidationProvider>

        <div v-if="label && select_label" style="height: 20px" />

        <ValidationProvider
          v-if="select_label"
          rules="required"
          v-slot="{ errors, valid }"
        >
          <FormSelect
            v-model="select_value"
            :label="select_label"
            :items="select_items"
            item-text="value"
            item-value="id"
            outlined
            required
          ></FormSelect>
        </ValidationProvider>
      </ValidationObserver>

      <FormTextInput
        v-if="!required && label"
        v-model="value"
        class="ml-auto"
        :label="label"
      />
      <FormSelect
        v-if="!required && select_label"
        v-model="select_value"
        :label="select_label"
        :items="select_items"
        item-text="value"
        item-value="id"
        outlined
        required
      ></FormSelect>
    </template>
  </UniversalDialog>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      label: "",
      value: "",
      select_value: null,
      text: null,
      initial_value: "",
      string_state: true,
      context: null,
      required: true,
      mustChange: false,
      okvariant: "primary",
      cancelvariant: "secondary",
      openDialog: false,
      dialogResolve: null,
      dialogReject: null,
      select_label: null,
      select_items: [],
    };
  },

  props: {
    showClose: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  methods: {
    show(
      title,
      label,
      text,
      initial_value,
      select_label,
      select_initial_value,
      select_items,
      context = null,
      required = true,
      mustChange = true,
      okvariant = "primary",
      cancelvariant = "secondary"
    ) {
      return new Promise((resolve, reject) => {
        this.value = initial_value;
        this.title = title;
        this.label = label;
        this.text = text;
        this.select_label = select_label;
        this.select_items = select_items;
        this.select_value = select_initial_value;
        this.initial_value = initial_value;
        this.okvariant = okvariant;
        this.cancelvariant = cancelvariant;
        this.dialogResolve = resolve;
        this.dialogReject = reject;
        this.openDialog = true;
        this.required = required;
        this.context = context;
        this.mustChange = mustChange;
      });
    },

    hide() {
      this.openDialog = false;
      this.dialogReject();
    },

    confirm() {
      if (!this.required || ((this.value && this.value.length > 0) || this.select_value)) {
        if (
          (this.value != this.initial_value &&
            this.select_value != this.select_initial_value) ||
          !this.mustChange
        ) {
          this.openDialog = false;
          this.dialogResolve({
            context: this.context,
            value: { text: this.value, select: this.select_value },
          });
        }
      }
    },

    dismiss() {
      this.hide();
    },

    closeDialog() {
      this.hide();
    },
  },
};
</script>
